export const environment = {
  production: true,
  local: false,
  api: 'https://registry.heybisi.com',
  n8n: 'https://apps1.betterchains.com',
  services: {
    schedule: 'https://schedule.heybisi.com',
    tasks: 'https://task-settings.heybisi.com'
  }
};
